import React from "react";
import { useNavigate } from "react-router-dom";

function Atendimento(props) {
  const navigate = useNavigate();

  const handlePress = () => {
    navigate(`agendamento/${props.id}`, {
      state: {
        titulo: props.nome,
        id: props.id,
      },
    });
  };

  return (
    <div
      onClick={handlePress}
      className="border-2 border-solid !bg-white border-[#003D42] mt-4 sm:mt-6 mx-5 p-5 rounded-md cursor-pointer select-none text-center"
    >
      <h2 className="text-[#003D42] text-202px font-extrabold m-0">{props.titulo}</h2>
      <p className="text-gray-500 text-16px font-medium mt-2 mb-0">{props.subtitulo}</p>
      <img
  src={props.imagem}
  alt={props.nome}
  className="mt-6 w-[80%] sm:w-[80%] md:w-full max-w-[500px] h-auto object-cover rounded"
/>


    </div>
  );
}

export default Atendimento;
